import { DocumentStatus, User } from '@/schema'

import { Owner, Reviewer, UserRole } from '../types'

export const isAllowedChangeTflStatus = (
  currentTflStatus: string,
  newTflStatus: string,
  roleContext: { isReviewer: boolean; isOwner: boolean }
): boolean => {
  if (currentTflStatus === newTflStatus) {
    return true
  }

  if (roleContext.isReviewer) {
    return false
  }

  if (roleContext.isOwner) {
    return (
      (currentTflStatus === DocumentStatus.QUERY_RAISED &&
        newTflStatus === DocumentStatus.UNDER_REVISION) ||
      (currentTflStatus === DocumentStatus.UNDER_REVISION &&
        newTflStatus === DocumentStatus.QUERY_RAISED)
    )
  }

  return false
}

export function canDeleteDocument(status: DocumentStatus | string): boolean {
  return [DocumentStatus.NEW, DocumentStatus.IN_REVIEW].includes(
    status as DocumentStatus
  )
}

export function isUserReviewer(
  reviewers: Reviewer[] | User[] | undefined | null,
  userId: string | undefined
): boolean {
  if (!reviewers || !userId) return false
  return reviewers.some((reviewer) => reviewer.id === userId)
}

export function isUserCreator(
  owner: Owner | undefined,
  userId: string | undefined
): boolean {
  if (!owner || !userId) return false
  return owner.id === userId
}

export function getUserRole(
  owner: Owner | undefined,
  createdBy: string | undefined,
  reviewers: Reviewer[] | undefined,
  userId: string | undefined
): UserRole {
  const isOwner = isUserCreator(owner, userId)
  const isAuthor = createdBy === userId
  const isReviewer = isUserReviewer(reviewers, userId)

  if (isOwner && !isReviewer) return UserRole.OWNER_AUTHOR
  if (isAuthor && isReviewer) return UserRole.AUTHOR_REVIEWER
  if (isAuthor) return UserRole.AUTHOR
  if (isReviewer) return UserRole.REVIEWER
  return UserRole.VIEWER
}
